import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  actionsWrapper: {
    position: 'absolute',
    top: '52px',
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '24px',
    backgroundColor: '#65656580',
    borderRadius: '6px 0 0 6px',
    zIndex: 1,
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    '& .heard': {
      color: whiteColor,
    },
    '& .heard.active': {
      color: theme.palette.grey['400'],
    },
  },
}));
